// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post, put, multipart } from '../../../../common/api'
import { GET_USER, ADD_USER, EDIT_USER, DELETE_USER, ADD_USER_DOCUMENT, VIEW_USER, DELETE_DOCUMENT, EDIT_DOCUMENT } from '../../../../common/constant'

export const actionUserDocument = createAsyncThunk('appUserDocument/actionUserDocument', async (params, thunkAPI) => {
    return await post(GET_USER, params, thunkAPI)
})

//add user only
export const actionAddUserDocument = createAsyncThunk('appUserDocument/actionAddUserDocument', async (params, thunkAPI) => {
    return await put(ADD_USER, params, thunkAPI)
})

//add users documents 
export const actionUserDocumentAdd = createAsyncThunk('appUserDocument/actionUserDocumentAdd', async (params, thunkAPI) => {
    return await multipart(ADD_USER_DOCUMENT, params, thunkAPI)
})

export const actionGetUserDocument = createAsyncThunk('appUserDocument/actionGetUserDocument', async (params, thunkAPI) => {
    return await post(VIEW_USER, params, thunkAPI)
})

export const actionEditUserDocument = createAsyncThunk('appUserDocument/actionEditUserDocument', async (params, thunkAPI) => {
    return await post(EDIT_USER, params, thunkAPI)
})

//delete user only
export const actionDeleteUserDocument = createAsyncThunk('appUserDocument/actionDeleteUserDocument', async (params, thunkAPI) => {
    return await post(DELETE_USER, params, thunkAPI)
})

//delete document
export const actionDocumentDelete = createAsyncThunk('appUserDocument/actionDocumentDelete', async (params, thunkAPI) => {
    return await post(DELETE_DOCUMENT, params, thunkAPI)
})

//edit document
export const actionDocumentEdit = createAsyncThunk('appUserDocument/actionDocumentEdit', async (params, thunkAPI) => {
    return await post(EDIT_DOCUMENT, params, thunkAPI)
})

export const appUserDocumentSlice = createSlice({
    name: 'appUserDocument',
    initialState: {
        //list
        loading: false,
        userDocument: null,

        //add User
        loadingAdd: false,
        addUserDocument: null,

        //add Users Document
        loadingDocumentAdd: false,
        userDocumentAdd: null,

        // //get
        loadingGet: false,
        getUserDocument: null,

        //edit
        loadingEdit: false,
        editUserDocument: null,

        //delete
        loadingDelete: false,
        deleteUserDocument: null,

        //delete Document
        loadingDeleteDocument: false,
        documentDelete: null,

        //edit Document
        loadingEditDocument: false,
        documentEdit: null

    },
    reducers: {
        //reset or delete Add Insurance Company store data
        resetUserDocumentResponse: (state) => {
            state.userDocument = null
        },
        resetAddUserDocumentResponse: (state) => {
            state.addUserDocument = null
        },
        //users Documents add
        resetUserDocumentAddResponse: (state) => {
            state.userDocumentAdd = null
        },
        resetGetUserDocumentResponse: (state) => {
            state.getUserDocument = null
        },
        resetEditUserDocumentResponse: (state) => {
            state.editUserDocument = null
        },
        resetDeleteUserDocumentResponse: (state) => {
            state.deleteUserDocument = null
        },
        resetDocumentDeleteResponse: (state) => {
            state.documentDelete = null
        },
        resetDocumentEditResponse: (state) => {
            state.documentEdit = null
        }
    },
    extraReducers: builder => {
        builder
            //list
            .addCase(actionUserDocument.pending, (state) => {
                state.loading = true
            })
            .addCase(actionUserDocument.fulfilled, (state, action) => {
                state.loading = false
                state.userDocument = action.payload
            })
            .addCase(actionUserDocument.rejected, (state) => {
                state.loading = false
            })

            //add User only
            .addCase(actionAddUserDocument.pending, (state) => {
                state.loadingAdd = true
            })
            .addCase(actionAddUserDocument.fulfilled, (state, action) => {
                state.loadingAdd = false
                state.addUserDocument = action.payload
            })
            .addCase(actionAddUserDocument.rejected, (state) => {
                state.loadingAdd = false
            })

            //Users Documents Add only
            .addCase(actionUserDocumentAdd.pending, (state) => {
                state.loadingDocumentAdd = true
            })
            .addCase(actionUserDocumentAdd.fulfilled, (state, action) => {
                state.loadingDocumentAdd = false
                state.userDocumentAdd = action.payload
            })
            .addCase(actionUserDocumentAdd.rejected, (state) => {
                state.loadingDocumentAdd = false
            })

            //get
            .addCase(actionGetUserDocument.pending, (state) => {
                state.loadingGet = true
            })
            .addCase(actionGetUserDocument.fulfilled, (state, action) => {
                state.loadingGet = false
                state.getUserDocument = action.payload
            })
            .addCase(actionGetUserDocument.rejected, (state) => {
                state.loadingGet = false
            })

            //edit
            .addCase(actionEditUserDocument.pending, (state) => {
                state.loadingEdit = true
            })
            .addCase(actionEditUserDocument.fulfilled, (state, action) => {
                state.loadingEdit = false
                state.editUserDocument = action.payload
            })
            .addCase(actionEditUserDocument.rejected, (state) => {
                state.loadingEdit = false
            })

            //delete
            .addCase(actionDeleteUserDocument.pending, (state) => {
                state.loadingDelete = true
            })
            .addCase(actionDeleteUserDocument.fulfilled, (state, action) => {
                state.loadingDelete = false
                state.deleteUserDocument = action.payload
            })
            .addCase(actionDeleteUserDocument.rejected, (state) => {
                state.loadingDelete = false
            })

            //delete document
            .addCase(actionDocumentDelete.pending, (state) => {
                state.loadingDeleteDocument = true
            })
            .addCase(actionDocumentDelete.fulfilled, (state, action) => {
                state.loadingDeleteDocument = false
                state.documentDelete = action.payload
            })
            .addCase(actionDocumentDelete.rejected, (state) => {
                state.loadingDeleteDocument = false
            })

            //edit document
            .addCase(actionDocumentEdit.pending, (state) => {
                state.loadingEditDocument = true
            })
            .addCase(actionDocumentEdit.fulfilled, (state, action) => {
                state.loadingEditDocument = false
                state.documentEdit = action.payload
            })
            .addCase(actionDocumentEdit.rejected, (state) => {
                state.loadingEditDocument = false
            })
    }
})
export const { resetUserDocumentResponse, resetAddUserDocumentResponse, resetUserDocumentAddResponse, resetGetUserDocumentResponse, resetEditUserDocumentResponse, resetDeleteUserDocumentResponse, resetDocumentDeleteResponse, resetDocumentEditResponse } = appUserDocumentSlice.actions

export default appUserDocumentSlice.reducer